import { apiClient } from "@api/apiClient";

const API_ENDPOINT = {
  getPressTitleRegexInformation: "/edb/regex-processor/patterns/",
};

export const pressTitleRegexApis = {
  getPressTitleRegexInformation: async () => {
    const response = await apiClient.get(
      API_ENDPOINT.getPressTitleRegexInformation,
    );
    return response.data;
  },
};
